<template>
    <div class="trz_leave_settings">

        <b-overlay :show="showoverlay" rounded="sm" class="col-md-12">

            <div class="row ">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            Leave Year/Contract Date Range From {{ startDate }} To {{ endDate }}
                        </div>

                        <div class="card-body " v-if="available.length > 0">
                            <div class="row">
                                <!-- Abdullah26 chnaged sm-6 to md-6  -->
                                <div class="col-md-6 mobile-left-right-padding">

                                    <b-form-group id="leave_date-group" label="Leave Date [YYYY-MM-DD]" label-for="leave_date" class="required-field mb-0 mr-2 mb-2">
                                        <b-input-group class="mb-0">
                                        <b-form-input id="leave_date" name="leave_date" v-model="fdata.leave_date" v-validate="{ required: true, date_format: 'yyyy-mm-dd' }" type="text" placeholder="YYYY-MM-DD"
                                                        autocomplete="off" :state="validateState('leave_date')" aria-describedby="leave_date-feedback" data-vv-as="Leave Date"/>
                                        <b-input-group-append class="mb-0">
                                            <b-form-datepicker class="mb-0" id="day_one" button-only right locale="en-US" v-model="fdata.leave_date" />
                                        </b-input-group-append>
                                        <b-form-invalid-feedback id="leave_date-feedback">
                                            {{ veeErrors.first('leave_date') }}
                                        </b-form-invalid-feedback>
                                        </b-input-group>
                                    </b-form-group>
                                </div>

                                    <!-- Abdullah26 chnaged sm-6 to md-6  -->
                                <div class="col-md-6 mobile-left-right-padding">
                                    <b-form-group id="attendance_date-group" label="Available Dates"
                                        class="required-field" label-for="attendance_date" style="width: 100%;">
                                        <b-form-select id="attendance_date" name="attendance_date"
                                            v-model="fdata.attendance_date" v-validate="{ required: true }"
                                            :options="available" :state="validateState('attendance_date')"
                                            aria-describedby="attendance_date-feedback" data-vv-as="Available Dates"
                                            style="width: 100%;"></b-form-select>
                                        <b-form-invalid-feedback id="attendance_date-feedback">{{
                                            veeErrors.first('attendance_date') }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </div>

                                <div class="col-12">
                                    <b-form-group id="reason-group" label="Reason" class="required-field"
                                        label-for="reason">
                                        <b-form-textarea id="reason" name="reason" rows="3" max-rows="6"
                                            v-model="fdata.reason" v-validate="{ required: true }"
                                            :state="validateState('reason')" aria-describedby="reason-feedback"
                                            data-vv-as="Reason"></b-form-textarea>
                                        <b-form-invalid-feedback id="reason-feedback">{{ veeErrors.first('reason')
                                        }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                            </div>

                            <div class='mt-2'>
                                <div class="clearfix">
                                    <div class="float-left"><b-button @click="saveLeave()">Save</b-button></div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body " v-else>No available dates.</div>
                    </div>
                </div>
            </div>

            <div class="card mt-4">

                <div class="col-sm-12">
                    <div class="card-header table-head">Allowed Leaves</div>
                    <div class="card-body ">
                        <table class="table table-responsive">
                            <thead>
                                <tr class="table-head">
                                    <th>Leave Date</th>
                                    <th>Used Attendance Date</th>

                                    <th>Updated By/Initiated By</th>
                                    <th>Status</th>
                                    <!-- <th>Action</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="table-row hover-bg" v-for="leave in compensatory_leave_list" :key="leave.id">
                                    <td>{{ leave.leave_date }}</td>
                                    <td>{{ leave.attendance_date }}</td>
                                    <td>{{ leave.updated_by }}</td>

                                    <td>{{ status[leave.status].text }}</td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>

            </div>
        </b-overlay>

    </div>
</template>
<script>

import moment from 'moment'

export default {

    mounted() {
        this.$nextTick(() => {
            this.$validator.validate('leave_date');
        });
    },
    components: {

    },
    data() {
        const today = moment().format('YYYY-MM-DD');

        return {

            startDate: null,
            endDate: null,

            showoverlay: false,

            fdata: { leave_date: today, attendance_date: null, status: 0, reason: '' },

            compensatory_leave_list: [],
            available: [],

            blankmsg: '',

            status: [
                { text: 'Applied', value: '0' },
                { text: 'Approved', value: '1' },
                { text: 'Declined', value: '2' },
            ],
        }
    },
    methods: {

        getLeaves: function () {
            this.showoverlay = true;
            axios.get(this.$api_url + '/front/compensatory-leave-list').then(function (response) {

                if (response.data.length != 0) {

                    this.compensatory_leave_list = response.data.compensatory_leave_list;

                    this.available = response.data.available;


                    this.startDate = response.data.leave_limit_start_date;
                    this.endDate = response.data.leave_limit_end_date;


                    if (this.compensatory_leave_list.length == 0) {
                        this.blankmsg = 'Looks like no leave applied for the employee yet.';
                    }

                }

                this.showoverlay = false;

            }.bind(this));

        },
        saveLeave() {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }

                this.showoverlay = true;

                let formData = new FormData();
                for (let [key, value] of Object.entries(this.fdata)) {
                    formData.append(key, value);
                }

                axios.post(this.$api_url + '/front/compensatory-leave-save', formData)
                    .then(response => {
                        this.$bvToast.toast(response.data.message || 'Saved successfully.', {
                            title: response.data.toast_title || 'Success',
                            variant: response.data.toast_variant || 'success',
                            solid: true
                        });

                        if (response.data.status != 200) {
                            return;
                        }

                        this.getLeaves();
                        this.$emit('childToParent');
                    })
                    .catch(error => {
                        const message =
                            error.response && error.response.data && error.response.data.message
                                ? error.response.data.message
                                : 'An unexpected error occurred.';

                        this.$bvToast.toast(message, {
                            title: 'Error',
                            variant: 'danger',
                            solid: true
                        });
                    })
                    .finally(() => {
                        this.showoverlay = false;
                    });
            });
        }
        ,
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },

    },
    created: function () {

        this.getLeaves();
    },
    computed:
    {

    }
}
</script>
